import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import "./SceletonNetworkGroups.scss"

const SceletonNetworkGroups = ({}) => {

    return (
        <div className='sceleton-network-groups'>
            <Stack className='sceleton-network-groups__content'>
                <Skeleton  className='sceleton-network-groups__item' variant="rectangular" />
            </Stack>
        </div>
    )
}

export { SceletonNetworkGroups }